import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPoint } from '@retailer-platform/dashboard/routing'
import { instacartDeveloperPlatformRouter } from './routing/instacartDeveloperPlatformRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import ES_ES from './translations/es-ES.json'
import FR_FR from './translations/fr-FR.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { instacartDeveloperPlatformAccessControl } from './access-control/instacartDeveloperPlatformAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'instacart-developer-platform',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'instacart-developer-platform-dashboard-tool',
  },
  routes,
  translations: { EN_US, ES_ES, FR_FR },
  routers: {
    partnerScoped: [instacartDeveloperPlatformRouter],
  },
  navigationEntries: [
    {
      attachToV2: NavEntryPoint.Developer,
      subNavItems: [
        {
          type: 'item',
          llmDescription: 'Getting started guide for Instacart developer platform integration',
          labelId: 'instacartDeveloperPlatformDomain.getStartedPage.title',
          route: 'instacart-developer-platform-get-started',
          accessControl: instacartDeveloperPlatformAccessControl,
          position: 0,
          positionNavV2: 0,
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
